import { pageMeta } from "../../pages/pageMetadata";
import type { SiteDesign } from "../../themes";
import type { EditorBlock, EditorPage } from "../editor.types";

/** The drag type an image from the Media section carries (its asset id). */
export const MEDIA_DRAG_TYPE = "application/x-hazumu-asset";

/** Asset ids a block shows: its own picture, or a carousel's images. */
export const blockAssets = (block: EditorBlock): string[] => {
  const ids = block.asset_id ? [block.asset_id] : [];
  const items = (block.content as { items?: unknown } | null)?.items;
  if (Array.isArray(items))
    for (const item of items) {
      const id = (item as { assetId?: unknown } | null)?.assetId;
      if (typeof id === "string") ids.push(id);
    }
  return ids;
};

/**
 * Where an image is used across the site: the pages showing it, work cards
 * using it as their cover, and the logo or site icon. Each place once.
 */
export function mediaUsage(
  assetId: string,
  { documents, pages, design }: {
    documents: Record<string, EditorBlock[]>;
    pages: EditorPage[];
    design: SiteDesign;
  },
): string[] {
  const places = new Set<string>();
  if (design.logo === assetId) places.add("Logo");
  if (design.icon === assetId) places.add("Site icon");
  for (const page of pages) {
    const title = page.title || "Untitled";
    if ((documents[page.id] ?? []).some((block) => blockAssets(block).includes(assetId))) places.add(title);
    const cover = pageMeta(page).cover as { assetId?: unknown } | null | undefined;
    if (cover && typeof cover === "object" && cover.assetId === assetId) places.add(`${title} (card cover)`);
  }
  return [...places];
}
